var cov_fmiztohsh = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tree/Root.tsx",
      hash = "ecce0685b80103ffb9d504b968c467ef6131a470",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tree/Root.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 20
        },
        end: {
          line: 9,
          column: 119
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 88
        }
      },
      "2": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 17,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "Root",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 13
          }
        },
        loc: {
          start: {
            line: 8,
            column: 80
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 46
          },
          end: {
            line: 9,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 59
          },
          end: {
            line: 9,
            column: 70
          }
        }, {
          start: {
            line: 9,
            column: 73
          },
          end: {
            line: 9,
            column: 82
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 84
          },
          end: {
            line: 9,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 84
          },
          end: {
            line: 9,
            column: 91
          }
        }, {
          start: {
            line: 9,
            column: 95
          },
          end: {
            line: 9,
            column: 100
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tree/Root.tsx";
import React from 'react';
import classnames from 'classnames';
import { treeClass } from './styles';
import List from './List';
import { isRTL } from '../config';

function Root(props) {
  cov_fmiztohsh.f[0]++;
  var className = (cov_fmiztohsh.s[0]++, classnames(treeClass('_', props.line ? (cov_fmiztohsh.b[0][0]++, 'with-line') : (cov_fmiztohsh.b[0][1]++, 'no-line'), (cov_fmiztohsh.b[1][0]++, isRTL()) && (cov_fmiztohsh.b[1][1]++, 'rtl')), props.className));
  cov_fmiztohsh.s[1]++;
  return (
    /*#__PURE__*/
    React.createElement(List, Object.assign({}, props, {
      className: className,
      expanded: true,
      path: "",
      isRoot: true,
      deepIndex: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11,
        columnNumber: 10
      }
    }))
  );
}

cov_fmiztohsh.s[2]++;
Root.defaultProps = {
  data: [],
  line: true
};
export default Root;